export default __webpack_public_path__ + "static/cards-31458c0564c80a3cb62937e1d051ac4a.gif";